module.exports = __webpack_public_path__ + "static/media/antes20mg.3b859360.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-alambrico/antes20mg.png
// module id = 99
// module chunks = 0